import { Link } from "react-router-dom";
import { Hammer, Palette, Network, ArrowRight } from "lucide-react";
import { GROUPS } from "../data/conferenceData";

const ICON_MAP = {
  construct: Hammer,
  palette: Palette,
  network: Network,
};

export default function Group() {
  return (
    <div style={{ padding: "16px", paddingBottom: "40px" }} data-testid="group-page">
      <h2
        style={{
          fontSize: "22px",
          fontWeight: 800,
          color: "var(--primary-dark)",
          marginBottom: "6px",
        }}
      >
        Assigned Group
      </h2>

      <p
        style={{
          color: "var(--text-muted)",
          fontSize: "14px",
          marginBottom: "16px",
          lineHeight: "20px",
        }}
      >
        As professionals and role models for our students, we ask that all
        teachers follow the established expectations and procedures throughout
        the professional development experience.
      </p>

      <p
        style={{
          color: "var(--text-muted)",
          fontSize: "14px",
          marginBottom: "16px",
          lineHeight: "20px",
        }}
      >
        At check-in, you will confirm your grade-level group for the day. Third-grade teachers will remain together, fourth-grade teachers will remain together, and fifth-grade teachers will remain together throughout the professional development experience. If you teach multiple grades, you will select a grade.
      </p>

      <p
        style={{
          color: "var(--text-muted)",
          fontSize: "14px",
          marginBottom: "16px",
          lineHeight: "20px",
        }}
      >
        Please remain with your assigned grade-level group for the entire day and tap your group in the app to view your personalized rotation schedule.
      </p>

      <p
        style={{
          color: "var(--text-muted)",
          fontSize: "14px",
          marginBottom: "20px",
          lineHeight: "20px",
        }}
      >
        Tap your assigned group to view your personalized rotation schedule.
      </p>

      <div className="flex flex-col" style={{ gap: "14px" }}>
        {GROUPS.map((g) => {
          const Icon = ICON_MAP[g.icon] || Hammer;
          const txt = g.textColor || "white";
          return (
            <Link
              key={g.id}
              to={`/group/${g.id}`}
              data-testid={`group-${g.id}`}
              className="shadow-group"
              style={{
                backgroundColor: g.color,
                borderRadius: "18px",
                padding: "18px",
                minHeight: "140px",
                display: "block",
              }}
            >
              {/* Top row: icon box + band tag */}
              <div
                className="flex items-center justify-between"
                style={{ marginBottom: "12px" }}
              >
                <div
                  className="flex items-center justify-center"
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "14px",
                    backgroundColor: g.accent,
                  }}
                >
                  <Icon size={26} color={g.color} strokeWidth={2} />
                </div>
                <div
                  className="flex items-center"
                  style={{
                    backgroundColor: g.accent,
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                    borderRadius: "999px",
                    gap: "6px",
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "5px",
                      backgroundColor: g.color,
                      display: "inline-block",
                    }}
                  />
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 800,
                      letterSpacing: "0.5px",
                      color: g.color,
                    }}
                  >
                    {g.bandLabel}
                  </span>
                </div>
              </div>

              <p
                style={{
                  fontSize: "19px",
                  fontWeight: 800,
                  marginBottom: "12px",
                  color: txt,
                }}
              >
                {g.name}
              </p>

              <div className="flex items-center" style={{ gap: "6px" }}>
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "13px",
                    color: txt,
                  }}
                  data-testid={`group-view-${g.id}`}
                >
                  View schedule
                </span>
                <ArrowRight size={14} color={txt} strokeWidth={2.2} />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
